import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/resources/MovementLogReport.jsx.
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'received', label: 'Received' },
  { value: 'issued', label: 'Issued' },
  { value: 'adjusted', label: 'Adjusted' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'item', label: 'Item' },
  { key: 'facility', label: 'Facility' },
  { key: 'type', label: 'Type' },
  { key: 'quantity_change', label: 'Qty Change', align: 'right' },
  { key: 'reason', label: 'Reason' },
  { key: 'user', label: 'User' },
  { key: 'occurred_at', label: 'Date' },
];

export function MovementLogReport() {
  return (
    <ReportView
      title="Inventory Movement Log"
      description="History of inventory received, issued and adjusted."
      endpoint="/reports/resources/movement-log"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
